<template>
    <div>
        <div class="nav primary-bg pl20 pr20 pt10 pb10">
            <div class="box-horizontal">
                <div class="" @click="met.back()">
                    <img src="@/assets/back.png" alt="" style="height:30px;opacity:0;" >
                </div>
                <div class="flex-1 f13 text-center white">
                    Bayar Tagihan
                </div>
                <div class="">
                    <img src="@/assets/back.png" alt="" style="height:30px;opacity:0;" >
                </div>
            </div>
        </div>
        
        <div class="main" v-if="get.data.isNomerTidakAda == true">
            <div class="wrapper wrapper-loading">
                <div class=" body-box box-1 mt10 mb10 p10 bg-white text-center">
                    <img src="@/assets/no.png" class="mb5" style="width: 75px;" />
                    <span class="f15 block red" style="font-size: 20pt"><strong>Oops...</strong></span>
                    <span class="f15 block ">Nomer tidak ditemukan</span>
                </div>
            </div>
        </div>
        
        <div class="main" v-else>
            <div class="wrapper wrapper-loading" v-show="get.data.lunasAll">
                <div class=" body-box box-1 mt10 mb10 p10 bg-white text-center">
                    <img src="@/assets/cek.png" class="mb5" style="width: 75px;" />
                    <span class="f15 block green" style="font-size: 20pt"><strong>LUNAS</strong></span>
                    <span class="f15 block ">Tidak ada Tagihan</span>
                </div>
            </div>

            <div class="wrapper wrapper-loading" v-show="get.data.loadingTagihan">
                <div class=" body-box box-1 mt10 mb10 p10 bg-white">
                    <div class="loading" style="height:20px;"></div>
                </div>
                <div class=" body-box box-1 mt10 mb10 p10 bg-white">
                    <div class="loading" style="height:20px;"></div>
                </div>
                <div class=" body-box box-1 mt10 mb10 p10 bg-white">
                    <div class="loading" style="height:20px;"></div>
                </div>
                <div class=" body-box box-1 mt10 mb10 p10 bg-white">
                    <div class="loading" style="height:20px;"></div>
                </div>
            </div>
            <div class="wrapper" v-show="!get.data.loadingTagihan">
                <div class=" body-box box-1 mt10 mb10 p10 bg-white">
                    <span class="block mb10">Provider</span>
                    <div class="block">
                        <span class="f15 block primary-color">{{get.data.owner}}</span>
                        <span class="f12 block">{{get.data.ownerhp}}</span>
                    </div>
                </div>
                <div class=" body-box box-1 mt10 mb10 p10 bg-white">
                    <div class="box-horizontal">
                        <span class="flex-1 f13">Bulan Tagihan</span>
                        <span class="f13 primary-color text-right">
                            <span class="block">{{get.data.bulanText}}</span>
                            <span class="block">{{get.data.bulan1Text}}</span>
                            <span class="block">{{get.data.bulan2Text}}</span>
                            <span class="block">{{get.data.bulan3Text}}</span>
                            
                        </span>
                    </div>
                </div>
                <div class=" body-box box-1 mt10 mb10 p10 bg-white">
                    <span class="block mb10">Detail Pelanggan</span>
                    <div class="block">
                        <span class="f15 mb5 block primary-color">{{get.data.nama}}</span>
                        <span class="block">{{get.data.hp}}</span>
                    </div>
                </div>

                <div class=" body-box box-1 mt10 mb10 p10 bg-white">
                    <div class="rincian-box ">
                        <div class="box-horizontal">
                            <span class="f13 mb5 flex-1 gray">Rincian</span>
                        </div>
                        <div class="box-horizontal">
                            <span class="f13 mb5 flex-1">{{get.data.paket}} <span class="bg-round-blue p5 white" v-if="get.data.prorata == 'ya'">Prorata</span></span>
                            <span class="f13" v-if="get.data.prorata != 'ya'">{{get.data.paketTarif}}</span>
                            <span class="f13" v-else><del>{{get.data.paketTarif}}</del> {{myGlobal.ribu(get.data.tarifProrata)}}</span>
                        </div>
                        <div class="box-horizontal" v-if="get.data.tambahan1Tarif != null || get.data.tambahan2Tarif != null"> <!--    -->
                            <span class="flex-1">Biaya Tambahan</span>
                        </div>
                        <div class="box-horizontal" v-if="get.data.tambahan1Tarif != null ">
                            <span class="f13 mb5 flex-1">{{get.data.tambahan1}}</span>
                            <span class="f13">{{get.data.tambahan1Tarif}}</span>
                        </div>
                        <div class="box-horizontal" v-if="get.data.tambahan2Tarif != null ">
                            <span class="f13 mb5 flex-1">{{get.data.tambahan2}}</span>
                            <span class="f13">{{get.data.tambahan2Tarif}}</span>
                        </div>
                        <div class="box-horizontal" v-show="get.data.ppnPersen != '0'"> 
                            <span class="flex-1 ">PPN {{get.data.ppnPersen}}%</span>
                            <span class="f12">{{get.data.ppn}}</span> 
                        </div>
                        <div class="box-horizontal" v-show="get.data.diskon != 'Rp. 0'">
                            <span class="flex-1 ">Diskon</span>
                            <span class="f12 green">{{get.data.diskon}}</span>
                        </div>
                    </div>
                    <div class="box-horizontal mt20">
                        <span class="f13 "><strong>Jumlah</strong></span>
                        <span class="f13 flex-1 primary-color text-right"><strong>{{myGlobal.ribu(get.data.total)}}</strong></span>
                    </div>
                </div>
                
                <div class=" body-box box-1 mt10 mb10 p10 bg-white" v-show="get.data.via != null">
                    <div class="rincian-box ">
                        <div class="box-horizontal"> 
                            <span class="flex-1">Via</span>
                            <span class="f13 white mr10 pt5 pb5 pl10 pr10 btn btn-info" @click="met.gantiBayar()">Ganti</span>
                            <span class="f12 primary-color" style="text-transform: uppercase;">{{get.data.via}}</span> 
                        </div>
                        <div class="box-horizontal"> 
                            <span class="flex-1">Biaya Operasional Aplikasi</span>
                            <span class="f12">{{myGlobal.ribu(get.data.biayaAdmin)}}</span> 
                        </div>
                        <div class="box-horizontal" v-show="get.data.diskonOnline != 'Rp. 0'">
                            <span class="flex-1 ">Diskon Bayar Online</span>
                            <span class="f12 green">{{get.data.diskonOnline}}</span>
                        </div>
                        <div class="box-horizontal">
                            <span class="flex-1 f15"><strong>Total Pembayaran</strong></span>
                            <span class="f15 primary-color" v-if="get.data.diskonOnline == '0'" ><strong>{{myGlobal.ribu(get.data.totalAll)}}</strong></span>
                            <span class="f15 primary-color" v-else ><s class="f12 gray">{{myGlobal.ribu(get.data.totalAll)}}</s> <strong>{{myGlobal.ribu(get.data.totalAll - get.data.totalDiskonOnline)}}</strong></span>
                        </div>
                    </div>
                </div>
                
                <div>
                    <button class="btn btn-info w100" v-if="!get.data.lunasAll" v-show="!get.data.bayarBox" @click="met.bayarSekarang()">Bayar Sekarang</button>
                </div>

                <div class="body-box box-1 mt10 mb10 pt10 pb10 bg-white" v-show="get.data.bayarBox">
                    <span class="mb10 block f15">Pilih Metode Pembayaran</span>

                    <div class="bayar-title ">
                        <span class="block hitam">Dompet Digital</span>
                        <small class="biru text-right">*Terdapat Biaya Operasional</small>
                    </div>
                    <div class="bayar-item last " v-bind:class="{'comingsoon' : get.data.viaQris === 'tidak'}" @click="met.via('qris','qris')">
                        <img src="@/assets/qris.png" />
                        <span>QRIS (QR berstandar resmi Indonesia)</span>
                    </div>
                    <!--
                    <div class="bayar-item comingsoon" v-bind:class="{'comingsoon' : get.data.viaQris === 'tidak'}" @click="met.via('ovo','qris')"> 
                        <img src="@/assets/ovo.png" />
                        <span>Ovo</span>
                    </div>
                    <div class="bayar-item comingsoon" v-bind:class="{'comingsoon' : get.data.viaQris === 'tidak'}" @click="met.via('dana','qris')"> 
                        <img src="@/assets/dana.png" />
                        <span>Dana</span>
                    </div>
                    <div class="bayar-item comingsoon" v-bind:class="{'comingsoon' : get.data.viaQris === 'tidak'}" @click="met.via('link','qris')"> 
                        <img src="@/assets/link.png" />
                        <span>Link Aja</span>
                    </div> -->

                    <div class="bayar-title mt20">
                        <span class="block hitam">Outlet</span>
                        <small class="biru text-right">Biaya Admin Flat Alfamart dan Alfamidi Rp. 6.000 dan Indomaret Rp. 8000,, Minimal Pembayaran Rp. 10.000</small>
                    </div>
                    <div class="bayar-item " @click="met.via('INDOMARET','tripay-outlet')" v-bind:class="{'comingsoon' : get.data.viaIndomaret === 'tidak'}"> <!--    -->
                        <img src="@/assets/indomaret.png" />
                        <div>
                            <span style="display:block">Indomaret</span>
                            <small style="color: #c0392b" v-if="get.data.custom !== 'custom'">Maaf, hubungi Provider Internet anda untuk menggunakan pembayaran ini</small>
                        </div>
                    </div>
                    <div class="bayar-item" @click="met.via('ALFAMART','outlet')" v-bind:class="{'comingsoon' : get.data.viaAlfamart === 'tidak'}"> <!--   -->
                        <img src="@/assets/alfamart.png" />
                        <div>
                            <span style="display:block">Alfamart</span>
                            <small style="color: #c0392b" v-if="get.data.custom !== 'custom'">Maaf, hubungi Provider Internet anda untuk menggunakan pembayaran ini</small>
                        </div>
                    </div>
                    <div class="bayar-item last" @click="met.via('ALFAMART','outlet')" v-bind:class="{'comingsoon' : get.data.viaAlfamidi === 'tidak'}">
                        <img src="@/assets/alfamidi.png" />
                        <div>
                            <span style="display:block">Alfamidi</span>
                            <small style="color: #c0392b" v-if="get.data.custom !== 'custom'">Maaf, hubungi Provider Internet anda untuk menggunakan pembayaran ini</small>
                        </div>
                    </div>

                    
                    <div class="bayar-title mt20">
                        <span class="block hitam">Virtual Account</span>
                        <small class="biru text-right">Biaya Admin Flat Rp. 6.000</small>
                    </div>
                    <div class="bayar-item" @click="met.via('MANDIRI','va')" v-bind:class="{'comingsoon' : get.data.viaMandiri === 'tidak'}">
                        <img src="@/assets/mandiri.png" />
                        <span>Mandiri Virtual Akun</span>
                    </div>
                    <div class="bayar-item" @click="met.via('BRI','va')" v-bind:class="{'comingsoon' : get.data.viaBRI === 'tidak'}"> <!--   -->
                        <img src="@/assets/bri.png" />
                        <span>BRI Virtual Akun</span>
                    </div>
                    <div class="bayar-item" @click="met.via('BNI','va')" v-bind:class="{'comingsoon' : get.data.viaBNI === 'tidak'}">
                        <img src="@/assets/bni.png" />
                        <span>BNI Virtual Akun</span>
                    </div>
                    <div class="bayar-item" v-bind:class="{'comingsoon' : get.data.viaPermata === 'tidak'}" @click="met.via('PERMATA','va')">
                        <img src="@/assets/permata.png" />
                        <span>PERMATA Virtual Akun</span>
                    </div>
                    <div class="bayar-item comingsoon" @click="met.segera()">
                        <img src="@/assets/bca.png" />
                        <span>BCA Virtual Akun</span>
                    </div>
                </div>
            </div>
        </div>
        

        <div class="toast" v-show="get.data.toastShow">
            <span class="text-center block w100">{{get.data.toastText}}</span>
        </div>
    </div>
</template>

<script>
import myGlobal from '@/MyGlobal'
import { reactive } from '@vue/composition-api'
import store from '@/store/index'
import inter from '@/Interface'
import router from '@/router'
import Loading from '@/global/Loading' 

export default {
    components: { 
        'Loading': Loading
    },
    setup() {
        const get = {
            data: reactive({
                loadingTagihan: true,
                toastShow: false,
                toastText: '',

                isNomerTidakAda: false,
                rincianBox: false,
                bayarBox: false,
                this: '',
                loading: true,
                uid: null,

                ownerid: null,
                owner: null,
                ownerhp: null,
                uid: null,
                nama: '',
                hp: '',
                total: '',
                paket: '',
                paketTarif: '',
                tambahan1: null,
                tambahan1Tarif: null,
                tambahan2: null,
                tambahan2Tarif: null,
                ppnPersen: 0,
                ppn: 0,
                diskon: 0,
                
                lunasAll: false,
                bulan: null,
                tahun: null,
                bulan1: null,
                tahun1: null,
                bulan2: null,
                tahun2: null,
                bulan3: null,
                tahun3: null,
                bulanText: '',
                bulan1Text: '',
                bulan2Text: '',
                bulan3Text: '',
                
                custom: null,
                viaQris: null,
                viaPermata: null,
                viaMandiri: null,
                viaBRI: null,
                viaBNI: null,
                viaAlfamart: null,
                viaAlfamidi: null,
                viaIndomaret: null,
                biayaAdmin: null,
                totalAll: 0,
                jenis: null, 
                via: null, // bayar via
                bayarKliked: false,
                prorata: null,
                tarifProrata: null,
                diskonOnline: null,
                totalDiskonOnline: null
            })
        }
        const met = {
            back() {
                window.history.back();
            },
            bayarSekarang() {
                if (get.data.via == null) {
                    get.data.bayarBox = !get.data.bayarBox
                    return false;
                }

                if (get.data.bayarKliked == true) {
                    return false;
                }

                get.data.bayarKliked = true;
                get.data.toastShow = true;
                get.data.toastText = "Tunggu Sebentar";

                // ke req pembayaran
                var datax = {
                    telepon: get.data.hp,
                    uid: get.data.uid,
                    ownerid: get.data.ownerid,
                    token: 'no-token',
                    via: get.data.via,
                    bulan: get.data.bulan,
                    tahun: get.data.tahun,
                    bulan1: get.data.bulan1,
                    tahun1: get.data.tahun1,
                    bulan2: get.data.bulan2,
                    tahun2: get.data.tahun2,
                    bulan3: get.data.bulan3,
                    tahun3: get.data.tahun3
                };

                //console.log(JSON.stringify(datax));

                //return false;

                //console.log(get.data.type);

                if (get.data.type =='qris') {
                    var apiUrl = inter.ReqBayar();
                } else if (get.data.type =='va') {
                    var apiUrl = inter.ReqBayarVA();
                } else if (get.data.type =='outlet') {
                    var apiUrl = inter.ReqBayarRetail();
                } else if (get.data.type =='tripay-outlet') {
                    //var apiUrl = inter.ReqBayarRetailTripay();
                    var apiUrl = inter.ReqBayarRetailIndomaret();
                }
                //console.log(JSON.stringify(apiUrl));


                myGlobal.call(datax,apiUrl).then(x => {
                    //data.loading = false;

                    // console.log(JSON.stringify(x));

                    myGlobal.android("loadingHide", null);

                    if (x.status == true) {
                        //this.data.hasil = x.pesan;

                        //theGet.data.Total = x.pesan;
                        if (get.data.type =='qris') {
                            router.push({ 
                                name: 'success', 
                                params: { 
                                    invoice: x.data.invoice, 
                                    via: get.data.via, 
                                    external_id: x.data.external_id, 
                                    qr:x.data.qr
                                } 
                            });
                        } else if (get.data.type =='va') {
                            router.push({ 
                                name: 'success-va', 
                                params: { 
                                    invoice: x.data.invoice, 
                                    via: get.data.via, 
                                    external_id: x.data.external_id, 
                                    data: x.data.respon
                                } 
                            });
                        } else if (get.data.type =='outlet') {
                            router.push({ 
                                name: 'success-retail', 
                                params: { 
                                    invoice: x.data.invoice, 
                                    via: get.data.via, 
                                    external_id: x.data.external_id, 
                                    data: x.data.respon
                                } 
                            });
                        } else if (get.data.type =='tripay-outlet') {
                            router.push({ 
                                name: 'success-tripay-retail', 
                                params: { 
                                    invoice: x.data.invoice, 
                                    via: get.data.via, 
                                    external_id: x.data.external_id, 
                                    data: x.data.respon
                                } 
                            });
                        }

                        //link.success();
                    } else {
                        
                    }

                })
            },
            gantiBayar() {
                get.data.via = null;
                get.data.bayarBox = !get.data.bayarBox;
            },
            via(via,type) { // outlet,va,qris

                if (type == "outlet") {
                    get.data.biayaAdmin = "6000";
                    if (get.data.total < 10000) {
                        
                        get.data.toastShow = true;
                        get.data.toastText = "Minimal pembayaran 10rb";
                        setTimeout(function() {
                            get.data.toastShow = false;
                        }, 3000);
                        
                        return false;

                    }
                } else if (type == "tripay-outlet") {
                    get.data.biayaAdmin = "8000";
                    if (get.data.total < 10000) {
                        
                        get.data.toastShow = true;
                        get.data.toastText = "Minimal pembayaran 10rb";
                        setTimeout(function() {
                            get.data.toastShow = false;
                        }, 3000);
                        
                        return false;

                    }
                } else if (type == "va") {
                    get.data.biayaAdmin = "6000";
                } else if (type == "qris") {
                    
                    if (get.data.viaQris == 'tidak') {
                        this.segera();
                        return;
                    }

                    //let persen = 0.02;
                    let totalS = get.data.total;
                    
                    let tarifX = totalS; 
                    console.log(tarifX);
                    let tarifX2persen = (parseInt(tarifX) / 100) * 2;
                    console.log(tarifX2persen);
                    let tarifX1persen = ((parseInt(tarifX) + parseInt(tarifX2persen)) / 100) * 1;
                    console.log(tarifX1persen);
                    let tarifX4000 = parseInt(tarifX2persen) + parseInt(tarifX1persen) + 4000 ;
                    console.log(tarifX4000);

                    console.log("halo bro 2")

                    get.data.biayaAdmin = tarifX4000;

                    //get.data.biayaAdmin = parseInt(totalS) * persen;

                    console.log(totalS);
                }

                get.data.type = type;
                get.data.via = via;
                get.data.bayarBox = false;

                get.data.totalAll = parseInt(get.data.total) + parseInt(get.data.biayaAdmin);
            },
            segera() {
                myGlobal.android("toast", "Segera ya bun :)");
            },
            detail(xdata) {
                router.push({ 
                    name: 'history-detail', 
                    params: {
                        data: xdata
                    } 
                });
            },
            tagihancek() {
                //console.log(get.data.uid);

                var datax = {
                    uid: get.data.uid
                };
            
                var apiUrl = inter.TagihanNoLogin(); 

                myGlobal.call(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));

                    get.data.loadingTagihan = false;

                    if (x.status == "tidak-ada") {
                        alert("Pelanggan tidak ditemukan");
                        return false;
                    }
    
                    if (x.status == true) {
                        var d = x.data;
                        
                        sessionStorage.setItem('browserTokenUid', d.uid);

                        console.log("browserTokenUid tg : "+sessionStorage.getItem('browserTokenUid'))

                        var ppne = myGlobal.sParseInt(d.ppn);
                        var ppn = (parseInt(ppne) / 100 ) * parseInt(d.tarif);

                        var tariff = ( myGlobal.sParseInt(d.tarif) + myGlobal.sParseInt(d.tambahan1) + myGlobal.sParseInt(d.tambahan2) + ppn ) - myGlobal.sParseInt(d.diskon);

                        var tarifx = tariff;

                        // jika lunas all ini true
                        if (d.isBayar == "sudah") {
                            /*
                            // PRORATA PART
                            if (d.prorata == "ya") {
                                get.data.lunasAll = false;
                                get.data.prorata = d.prorata;
                                get.data.tarifProrata = d.tarifProrata;
                                ppn = (parseInt(ppne) / 100 ) * parseInt(d.tarifProrata);
                                tariff = ( myGlobal.sParseInt(d.tarifProrata) + myGlobal.sParseInt(d.tambahan1) + myGlobal.sParseInt(d.tambahan2) + ppn ) - myGlobal.sParseInt(d.diskon);
                                tarifx = tariff;
                                tariff = ( myGlobal.sParseInt(d.tarif) + myGlobal.sParseInt(d.tambahan1) + myGlobal.sParseInt(d.tambahan2) + ppn ) - myGlobal.sParseInt(d.diskon);
                            } else {
                                */
                                get.data.lunasAll = true;
                            //}
                        } 

                        get.data.ownerid = d.ownerid;
                        get.data.owner = d.owner;
                        get.data.ownerhp = d.ownerhp;
                        get.data.uid = d.uid;
                        get.data.nama = d.nama;
                        get.data.hp = d.wa;
                        get.data.paketTarif = myGlobal.ribu(d.tarif);
                        

                        get.data.paket = d.paket; 
                        get.data.ppnPersen = myGlobal.sParseInt(d.ppn); 
                        get.data.ppn = myGlobal.ribu(myGlobal.sParseInt(ppn));
                        if (myGlobal.sParseInt(d.tambahan1) != 0) {
                            get.data.tambahan1 = d.rincian1;
                            get.data.tambahan1Tarif = myGlobal.ribu(d.tambahan1);
                        }
                        if (myGlobal.sParseInt(d.tambahan2) != 0) {
                            get.data.tambahan2 = d.rincian2;
                            get.data.tambahan2Tarif = myGlobal.ribu(d.tambahan2);
                        }
                        get.data.diskon = myGlobal.ribu(d.diskon); 

                        get.data.bulanText = d.bulanNow + " " + d.tahunAngka;

                        get.data.bulan = d.bulanAngka;
                        get.data.tahun = d.tahunAngka;

                        get.data.diskonOnline = myGlobal.ribu(d.diskon_online);
                        get.data.totalDiskonOnline = d.diskon_online;

                        if (d.bulanmin3data.isBayar != "sudah") {
                            if (d.bulanmin3data.isBayar != "register") {
                                get.data.bulan3Text = d.bulanmin3data.bulanText + " " + d.bulanmin3data.tahunAngka;
                                tarifx = tarifx + tariff;
                                
                                get.data.bulan3 = d.bulanmin3data.bulanAngka;
                                get.data.tahun3 = d.bulanmin3data.tahunAngka;
                                
                                get.data.totalDiskonOnline = myGlobal.sParseInt(get.data.totalDiskonOnline) + myGlobal.sParseInt(d.diskon_online);
                            }
                        }
                        
                        if (d.bulanmin2data.isBayar != "sudah") {
                            if (d.bulanmin2data.isBayar != "register") {
                                get.data.bulan2Text = d.bulanmin2data.bulanText + " " + d.bulanmin2data.tahunAngka;
                                tarifx = tarifx + tariff;
                                
                                get.data.bulan2 = d.bulanmin2data.bulanAngka;
                                get.data.tahun2 = d.bulanmin2data.tahunAngka;
                                
                                get.data.totalDiskonOnline = myGlobal.sParseInt(get.data.totalDiskonOnline) + myGlobal.sParseInt(d.diskon_online);
                            }
                        }
                        if (d.bulanmin1data.isBayar != "sudah") {
                            if (d.bulanmin1data.isBayar != "register") {
                                get.data.bulan1Text = d.bulanmin1data.bulanText + " " + d.bulanmin1data.tahunAngka;
                                tarifx = tarifx + tariff;
                                
                                get.data.bulan1 = d.bulanmin1data.bulanAngka;
                                get.data.tahun1 = d.bulanmin1data.tahunAngka;
                                
                                get.data.totalDiskonOnline = myGlobal.sParseInt(get.data.totalDiskonOnline) + myGlobal.sParseInt(d.diskon_online);
                            }
                        }          
                        
                        
                        get.data.total = tarifx;
                        
                        // IS CUSTOM?
                        get.data.custom = d.atipe;      
                        
                        var payment = d.payment;
                        for (let i = 0; i < payment.length; i++) {
            
                            if (payment[i].kode == 'qris') {
                                get.data.viaQris = payment[i].status;

                            } else if(payment[i].kode == 'PERMATA') {
                                get.data.viaPermata = payment[i].status;

                            } else if(payment[i].kode == 'MANDIRI') {
                                get.data.viaMandiri = payment[i].status;

                            } else if(payment[i].kode == 'BRI') {
                                get.data.viaBRI = payment[i].status;

                            } else if(payment[i].kode == 'BNI') {
                                get.data.viaBNI = payment[i].status;

                            } else if(payment[i].kode == 'ALFAMART') {
                                get.data.viaAlfamart = payment[i].status;

                            } else if(payment[i].kode == 'ALFAMIDI') {
                                get.data.viaAlfamidi = payment[i].status;

                            } else if(payment[i].kode == 'INDOMARET') {
                                get.data.viaIndomaret = payment[i].status;

                            }
                        }   

                    } else { 
                        get.data.isNomerTidakAda = true;
                    }
                })
            }
        }

        const redirectx = {
            checkApp() {
                myGlobal.checkApp();
            },
            now() {
                location.href="#/";
            }
        }

        return {
            met,
            get,
            redirectx,
            myGlobal
        }

    },
    mounted () {        
        sessionStorage.setItem('browserToken', "no-token");

        this.redirectx.checkApp();

        console.log(this.$route.params.uid);

        this.get.data.uid = this.$route.params.uid;
        
        this.met.tagihancek();

        
        console.log("browserTokenUid : "+sessionStorage.getItem('browserTokenUid'));
    }
}
</script>


// WEBPACK FOOTER //
// src/components/User/NoLogin/Detail/main.vue